import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import ScheduleVacationCreatePopup from "../../Vacation/ScheduleVacationCreatePopup";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";
import ReportPlaceholder from "../../Common/ReportPlaceholder";
import MnTooltipIcon from "../../Common/MnTooltipIcon";

class SubScheduleVacationList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            holidayScheduleCreateVisible: false, currentRow: null, viewName: 'Monthly'
        }
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentYear !== prevProps.currentYear) {
            this.initialize();
        }
    }

    initialize = async () => {
        try {
            this.key = {NumYear: this.props.currentYear, appid: window.AppInstanceId};
            await this.props.dispatch(this.props.SchedHolidayYear_GetTextBossPO.execute(this.key));
            await this.props.dispatch(this.props.ShedHolidayDetail_ListBossParPO.execute(this.key, {withParams: true}));
            if (this.props.methodInfo.IsSum === 1) {
                await this.props.dispatch(this.props.ShedHolidayDetail_ListBossSumPO.execute(this.key, {withStyle: true}));
            }
            if (this.props.methodInfo.IsDetail === 1) {
                await this.props.dispatch(this.props.ShedHolidayDetail_ListBossDetPO.execute(this.key, {withStyle: true}));
            }
            if (this.props.methodInfo.IsT7 === 1) {
                await this.props.dispatch(this.props.ShedHolidayDetail_SelNoEkdo.execute(this.key, {
                    withParams: true, withStyle: true
                }));
            }
        } catch (e) {
            console.error(e);
        } finally {
        }
    }

    createHolidaySchedule = async () => {
        this.setState({holidayScheduleCreateVisible: true});
    }

    /*
        refresh = async () => {
            await this.props.dispatch(this.props.ShedHolidayDetail_ListBossSumPO.refresh(this.key));
            if (this.props.methodInfo.IsDetail === 1) {
                await this.props.dispatch(this.props.ShedHolidayDetail_ListBossDetPO.refresh(this.key));
            }
        }

    */

    refresh = async () => {
        await this.props.dispatch(this.props.ShedHolidayDetail_ListBossSumPO.refresh(this.key));
        await this.props.dispatch(this.props.ShedHolidayDetail_ListBossDetPO.refresh(this.key));
    }

    closeHolidayScheduleCreate = (refresh = false) => {
        this.setState({holidayScheduleCreateVisible: false}, async () => {
            if (refresh) {
                await this.refresh();
            }
        })
    }

    cellClick = (row, fieldInfo, e) => {
        if (fieldInfo.Name !== 'Fix' && fieldInfo.Name !== 'UnFix' && fieldInfo.Name !== 'IsExclusion' && fieldInfo.Name !== 'NeedDaysPlan') this.setState({
            holidayScheduleCreateVisible: true, currentRow: row
        })
    }

    fix = async (row) => {
        const key = Object.assign({}, this.key, {CurTabNum: row.TabNum});
        await this.props.dispatch(this.props.ShedHolidayDetail_FixOne.execute(key));
        await this.refresh();
    }

    unFix = async (row) => {
        const key = Object.assign({}, this.key, {CurTabNum: row.TabNum});
        await this.props.dispatch(this.props.ShedHolidayDetail_UnfixOne.execute(key));
        await this.refresh();
    }

    fixAll = async () => {
        await this.props.dispatch(this.props.ShedHolidayDetail_FixAll.execute(this.key));
        await this.refresh();
    }

    setExclude = async (row) => {
        const key = Object.assign({}, this.key, {SubTabNum: row.TabNum, IsExclusion: (row.IsExclusion === 1 ? 0 : 1)});
        await this.props.dispatch(this.props.ShedHolidayDetail_SetExclude.execute(key));
        await this.refresh();
    }

    renderHeaderButtons = (viewName) => {
        function getReportKey(viewName) {
            let reportKey = '';
            switch (viewName) {
                case 'Monthly': {
                    reportKey = 'SchedHolSumPO';
                    break;
                }
                case 'Daily': {
                    reportKey = 'SchedHolDetPO';
                    break;
                }
                default: {
                    break;
                }
            }
            return reportKey;
        }

        const reportKey = getReportKey(viewName);
        return (<div className="px-3 text-right">
            {!this.props.readOnly && <button type="button"
                                             className="btn btn-regular -goahead  ml1ex"
                                             onClick={this.fixAll}>{i18next.t("Sub_Vacation_Schedule_List_1")}</button>}
            <ReportPlaceholder reportKey={reportKey} reportId={reportKey} title={i18next.t('ToExcel')}>
                {(reportParamsItem, build) => {
                    return (<>
                        <button className="btn btn-regular ml1ex"
                                onClick={async (e) => {
                                    e.preventDefault();
                                    await this.props.dispatch(reportParamsItem.setField(0, 'appid', window.AppInstanceId));
                                    await build();
                                }}>
                            {i18next.t('ToExcel')}
                        </button>

                    </>);
                }}
            </ReportPlaceholder>
        </div>)
    }

    renderParams = (h) => {
        return (<div className="row mx-auto">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    if (this.state.viewName === 'Monthly' && fi.Name === 'DateMonthName') {
                        return null;
                    }
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-9">
                                {h.ed(fn)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }

    renderCellEx = (cellParams) => {
        function getLink(isEnabled, className) {
            return (isEnabled ? <div style={{color: "brown", cursor: "pointer", textAlign: "center"}}><MnTooltipIcon
                    text={cellParams.row['Fix']} iconClass={className} key={cellParams.row['Fix']}/></div> :
                <div style={{color: "grey", cursor: "pointer", textAlign: "center"}}><i className={className}
                                                                                        key={cellParams.row['Fix']}/>
                </div>)
        }

        if (cellParams.fieldInfo.Name === 'Fix') {
            const className = cellParams.row['IsFix'] === 1 ? 'fas fa-lock' : 'fas fa-lock-open';
            const isEnabled = (cellParams.row['IsEnableFix'] === 1 || cellParams.row['IsEnableUnfix'] === 1/* || true*/);
            const link = getLink(isEnabled, className);
            if (isEnabled) {
                return (<ActionLink onSelect={async () => {
                    if (cellParams.row['IsEnableFix'] === 1) {
                        await this.fix(cellParams.row);
                    } else if (cellParams.row['IsEnableUnfix'] === 1) {
                        await this.unFix(cellParams.row);
                    }
                }}>
                    {link}
                </ActionLink>);
            } else {
                return link;
            }
            return null;
        } else if (cellParams.fieldInfo.Name === 'IsExclusion') {
            if (cellParams.row['IsEnableExclusion'] === 1) {
                return (<ActionLink onSelect={async () => {
                    await this.setExclude(cellParams.row);
                }}>
                    {cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex)}
                </ActionLink>)
            }
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    renderMsg = () => {
        if (!this.props.SchedHolidayYear_GetTextBossPO.isInitialized || this.props.SchedHolidayYear_GetTextBossPO.inOperation) return null;

        const isMess = this.props.SchedHolidayYear_GetTextBossPO.getField(0, 'IsMess');
        if (isMess === 0) {
            return null;
        }
        const mess_Text = this.props.SchedHolidayYear_GetTextBossPO.getField(0, 'Mess_Text');
        const mess_Clr = this.props.SchedHolidayYear_GetTextBossPO.getField(0, 'Mess_Clr');
        const mess_Size = this.props.SchedHolidayYear_GetTextBossPO.getField(0, 'Mess_Size');

        const mess_Text_Rows = mess_Text && mess_Text.split('\n');
        return (<PlaceholderWrapper placeholderId="10" collapsed={false} canCollapse={false} showSplitterLine={false}
                                    showHeaderTitle={false}>
            {mess_Text_Rows && mess_Text_Rows.map((row, index) => <div
                style={{color: `#${mess_Clr}`, fontSize: `${mess_Size}`}}>{row}</div>)}
        </PlaceholderWrapper>);
    }

    gridContentContainerStyleProvider = ({mobileMode}) => {
        if (!mobileMode) {
            //let height = window.innerHeight;
            let height = 500;
            return {
                minHeight: "150px", height: height + "px"
            };
        }
    }

    changeView = async (viewName, e) => {
        if (e) e.preventDefault();
        this.setState({viewName: viewName});
    }

    renderReportCell = (cellParams) => {
        if (cellParams.fieldInfo.Name === "SubView") {
            return (<ReportPlaceholder reportKey="T7-SchedHolOne" reportId="T7-SchedHolOne">
                {(reportParamsItem, build) => {
                    return (<>
                        <button className="btn mn-btn-link" onClick={async (e) => {
                            e.preventDefault();
                            //console.log(JSON.stringify(cellParams.row));
                            await this.props.dispatch(reportParamsItem.setField(0, 'NumYear', this.props.currentYear));
                            await this.props.dispatch(reportParamsItem.setField(0, 'SubTabNum', cellParams.row.SubTabNum));
                            await this.props.dispatch(reportParamsItem.setField(0, 'appid', window.AppInstanceId));
                            await build();
                        }}>
                            {cellParams.row.SubView}
                        </button>
                    </>);
                }}
            </ReportPlaceholder>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    selectAddress = async (e, rowParams) => {
        if (e) e.preventDefault();
        await this.props.dispatch(rowParams.dataItem.setField(rowParams.rowIndex, 'IsSet', (rowParams.row.IsSet === 1 ? 0 : 1)));
        await this.props.dispatch(rowParams.dataItem.save(rowParams.rowIndex));
    }

    renderSubgridRowEx = (rowParams) => {
        return (<div style={{cursor: "pointer"}} key={rowParams.rowIndex}
                     onClick={(e) => this.selectAddress(e, rowParams)}>
            <input type="checkbox" className="checkbox" checked={rowParams.row.IsSet === 1}
                   style={{cursor: "pointer"}} onChange={() => {
            }}/>&nbsp;
            {rowParams.row.AddressName ?? rowParams.row.ProfessionName}
        </div>)
    }

    renderSubgridRowEx_ListHolYearPO = (rowParams) => {
        return (<tr key={rowParams.rowIndex}>
            {rowParams.dataItem.rawData.ResultFieldInfo.map((fieldInfo, fieldIndex) => {
                if (!fieldInfo.IsHidden) {
                    return <td>{rowParams.row[fieldInfo.Name]}</td>
                }
            })}
        </tr>)
    }

    render() {
        const style = Object.assign({
            backgroundColor: "#fff",
            cursor: "pointer",
            ':active': {color: "#495057", borderColor: "#dee2e6 #dee2e6 #fff"}
        });
        const paramset = <ComplexParam dataItem={this.props.ShedHolidayDetail_ListBossParPO_Params}
                                       parentDataItem={this.props.ShedHolidayDetail_ListBossParPO}
                                       renderParams={this.renderParams}
                                       showApplyButton={false}
                                       autoApplyParams={true}
                                       afterApplyParams={this.refresh}
                                       autoFocusField="AdmStructName"
                                       showSearchBar={false}
            //                          onEndEditField={this.onEndEditField}
                                       renderSubgridRowEx={this.renderSubgridRowEx}
                                       maxSubgridWidthBody=""
                                       showSubgridHeader={false}
                                       rootPath="/"/>;
        const monthlyBlock = <>
            <br/>
            {this.renderHeaderButtons('Monthly')}
            <br/>
            {paramset}
            <span>&nbsp;</span>
            <GridView dataItem={this.props.ShedHolidayDetail_ListBossSumPO} readOnly={this.props.readOnly}
                      fixHeader={true}
                      contentContainerStyleProvider={this.gridContentContainerStyleProvider}
                      onCellClick={this.cellClick}
                      pageSize={10} allowPagination={true} activePageSize={5} rowCursor={"pointer"}
                      renderCellEx={this.renderCellEx}
                      renderSubgridRowEx={this.renderSubgridRowEx_ListHolYearPO}
                      maxSubgridWidthBody=""
                      useItemStyle={true}/>
        </>;

        const dailyBlock = <>
            <br/>
            {this.renderHeaderButtons('Daily')}
            <br/>
            {paramset}
            <span>&nbsp;</span>
            <GridView dataItem={this.props.ShedHolidayDetail_ListBossDetPO} readOnly={this.props.readOnly}
                      fixHeader={true}
                      contentContainerStyleProvider={this.gridContentContainerStyleProvider}
                      onCellClick={this.cellClick}
                      pageSize={10} allowPagination={true} activePageSize={5} rowCursor={"pointer"}
                      renderCellEx={this.renderCellEx}
                      renderSubgridRowEx={this.renderSubgridRowEx_ListHolYearPO}
                      maxSubgridWidthBody=""
                      useItemStyle={true}/>
        </>;
        const noEKDOBlock = <>
            <span>&nbsp;</span>
            <ComplexParam dataItem={this.props.ShedHolidayDetail_SelNoEkdo_Params}
                          parentDataItem={this.props.ShedHolidayDetail_SelNoEkdo}
                          renderParams={this.renderParams}
                          showApplyButton={false}
                          autoApplyParams={true}
                          readOnly={false}
                          showSearchBar={false}
                          rootPath="/"/>
            <span>&nbsp;</span>
            <GridView dataItem={this.props.ShedHolidayDetail_SelNoEkdo} readOnly={true}
                      fixHeader={true}
                      contentContainerStyleProvider={this.gridContentContainerStyleProvider}
                      renderCellEx={this.renderReportCell}
                      pageSize={10} allowPagination={true} activePageSize={5} rowCursor={"pointer"}
                      useItemStyle={true}/>
        </>;
        return (<>
            {this.renderMsg()}
            <>
                <ul className="nav nav-tabs" role="tablist" id="nav-tab">
                    {this.props.methodInfo.IsSum === 1 && <li className="nav-item" key="Monthly">
                        <a id="Monthly-tab" data-toggle="tab" href="#MonthlyBlock" className="nav-link active"
                           style={style} role="tab"
                           onClick={(e) => this.changeView('Monthly', e)}
                           aria-controls="MonthlyBlock" aria-selected="true">{i18next.t("By_Month")}
                        </a>
                    </li>}
                    {this.props.methodInfo.IsDetail === 1 && <li className="nav-item" key="Daily">
                        <a id="Daily-tab" data-toggle="tab" href="#DailyBlock" className="nav-link"
                           style={style} role="tab"
                           onClick={(e) => this.changeView('Daily', e)}
                           aria-controls="DailyBlock" aria-selected="false">{i18next.t("By_Day")}
                        </a>
                    </li>}
                    {this.props.methodInfo.IsT7 === 1 && <li className="nav-item" key="noEkdo">
                        <a id="NoEkdo-tab" data-toggle="tab" href="#NoEkdoBlock" className="nav-link"
                           style={style} role="tab"
                           onClick={(e) => this.changeView('noEkdo', e)}
                           aria-controls="NoEkdoBlock"
                           aria-selected="false">{i18next.t("Sub_Vacation_Schedule_List_2")}
                        </a>
                    </li>}
                </ul>
                <div className="tab-content">
                    {this.props.methodInfo.IsSum === 1 &&
                        <div id="MonthlyBlock" className="tab-pane show active inwhite card" role="tabpanel"
                             aria-labelledby="Monthly-tab">
                            {monthlyBlock}
                        </div>}
                    {this.props.methodInfo.IsDetail === 1 &&
                        <div id="DailyBlock" className="tab-pane inwhite card" role="tabpanel"
                             aria-labelledby="Daily-tab">
                            {dailyBlock}
                        </div>}
                    {this.props.methodInfo.IsT7 === 1 &&
                        <div id="NoEkdoBlock" className="tab-pane inwhite card" role="tabpanel"
                             aria-labelledby="NoEkdo-tab">
                            {noEKDOBlock}
                        </div>}
                </div>
            </>
            {this.state.holidayScheduleCreateVisible &&
                <ScheduleVacationCreatePopup currentYear={this.props.currentYear}
                                             onClose={this.closeHolidayScheduleCreate}
                                             dataItem={this.state.viewName === 'Monthly' ? this.props.ShedHolidayDetail_ListYearPO : this.props.ShedHolidayDetail_ListYearDetPO}
                                             readOnly={this.props.methodInfo.IsReadOnly === 1 || this.state.currentRow.ReadOnlyRow === 1}
                                             row={this.state.currentRow}
                />}
        </>);
    }
}

SubScheduleVacationList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentYear: PropTypes.number,
    methodInfo: PropTypes.object,
    readOnly: PropTypes.bool,
    ShedHolidayDetail_ListBossSumPO: PropTypes.object,
    ShedHolidayDetail_ListBossDetPO: PropTypes.object,
    SchedHolidayYear_GetTextBossPO: PropTypes.object,
    ShedHolidayDetail_FixOne: PropTypes.object,
    ShedHolidayDetail_UnfixOne: PropTypes.object,
    ShedHolidayDetail_FixAll: PropTypes.object,
    ShedHolidayDetail_ListYearPO: PropTypes.object,
    ShedHolidayDetail_ListYearDetPO: PropTypes.object,
    ShedHolidayDetail_SelNoEkdo: PropTypes.object,
    ShedHolidayDetail_SelNoEkdo_Params: PropTypes.object,
    ShedHolidayDetail_ListBossParPO: PropTypes.object,
    ShedHolidayDetail_ListBossParPO_Params: PropTypes.object,
    ShedHolidayDetail_SetExclude: PropTypes.object
}

SubScheduleVacationList.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        ShedHolidayDetail_ListBossSumPO: state.vacationState.ShedHolidayDetail_ListBossSumPO,
        ShedHolidayDetail_ListBossDetPO: state.vacationState.ShedHolidayDetail_ListBossDetPO,
        SchedHolidayYear_GetTextBossPO: state.vacationState.SchedHolidayYear_GetTextBossPO,
        ShedHolidayDetail_FixOne: state.vacationState.ShedHolidayDetail_FixOne,
        ShedHolidayDetail_UnfixOne: state.vacationState.ShedHolidayDetail_UnfixOne,
        ShedHolidayDetail_FixAll: state.vacationState.ShedHolidayDetail_FixAll,
        ShedHolidayDetail_ListYearPO: state.vacationState.ShedHolidayDetail_ListYearPO,
        ShedHolidayDetail_ListYearDetPO: state.vacationState.ShedHolidayDetail_ListYearDetPO,
        ShedHolidayDetail_SelNoEkdo: state.vacationState.ShedHolidayDetail_SelNoEkdo,
        ShedHolidayDetail_SelNoEkdo_Params: state.vacationState.ShedHolidayDetail_SelNoEkdo_Params,
        ShedHolidayDetail_ListBossParPO: state.vacationState.ShedHolidayDetail_ListBossParPO,
        ShedHolidayDetail_ListBossParPO_Params: state.vacationState.ShedHolidayDetail_ListBossParPO_Params,
        ShedHolidayDetail_SetExclude: state.vacationState.ShedHolidayDetail_SetExclude
    }
}

export default connect(mapStateToProps)(SubScheduleVacationList)